import { render, staticRenderFns } from "./function-settings.vue?vue&type=template&id=2700a7bf&scoped=true&lang=pug"
import script from "./function-settings.vue?vue&type=script&lang=js"
export * from "./function-settings.vue?vue&type=script&lang=js"
import style0 from "./function-settings.vue?vue&type=style&index=0&id=2700a7bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2700a7bf",
  null
  
)

export default component.exports